import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FIELDS = [
  ["name", "Nombre"],
  ["phone", "Teléfono"],
  ["service", "Servicio"],
  ["vehicle", "Vehículo"],
  ["preferred_date", "Fecha"],
  ["address", "Dirección"],
  ["notes", "Notas"],
  ["created_at", "Recibida"],
];

const Admin = () => {
  const [code, setCode] = useState("");
  const [bookings, setBookings] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${API}/bookings`, {
        headers: { "x-admin-code": code },
      });
      setBookings(res.data);
      toast.success(`${res.data.length} solicitudes cargadas`);
    } catch (err) {
      setError("Código incorrecto");
      toast.error("Código incorrecto");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink text-white px-5 py-10 md:py-16">
      <div className="mx-auto max-w-5xl">
        <div className="flex items-center justify-between">
          <Logo />
          <a href="/" className="text-sm text-white/50 hover:text-aqua transition-colors">
            ← Volver a la web
          </a>
        </div>

        {!bookings ? (
          <form
            onSubmit={login}
            data-testid="admin-login-form"
            className="mx-auto mt-24 max-w-sm glass rounded-3xl p-8"
          >
            <h1 className="font-display text-2xl font-bold">Panel de reservas</h1>
            <p className="mt-2 text-sm text-white/50">Introduce el código de acceso.</p>
            <input
              type="password"
              className="field mt-6"
              placeholder="Código de acceso"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              data-testid="admin-code-input"
            />
            {error && (
              <p className="mt-3 text-sm text-red-400" data-testid="admin-error">
                {error}
              </p>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-button"
              className="mt-5 w-full rounded-xl bg-aqua py-3.5 font-semibold text-ink transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,242,254,0.35)] disabled:opacity-50"
            >
              {loading ? "Cargando..." : "Entrar"}
            </button>
          </form>
        ) : (
          <div className="mt-12">
            <h1 className="font-display text-2xl font-bold mb-6">
              Solicitudes de reserva{" "}
              <span className="text-aqua font-mono text-base" data-testid="admin-booking-count">
                ({bookings.length})
              </span>
            </h1>
            {bookings.length === 0 && (
              <p className="text-white/50">Todavía no hay solicitudes.</p>
            )}
            <div className="grid gap-4">
              {bookings.map((b, i) => (
                <div
                  key={b._id}
                  data-testid="admin-booking-item"
                  className="glass rounded-2xl p-5 grid grid-cols-2 md:grid-cols-4 gap-4"
                >
                  {FIELDS.map(([k, label]) => (
                    <div key={k} className="min-w-0">
                      <p className="font-mono text-[10px] tracking-wider text-white/40 uppercase">{label}</p>
                      <p className="mt-1 text-sm text-white/85 break-words">
                        {k === "created_at" && b[k] ? new Date(b[k]).toLocaleString("es-ES") : b[k] || "—"}
                      </p>
                    </div>
                  ))}
                  <div className="col-span-2 md:col-span-4 flex items-center justify-between border-t border-white/10 pt-3">
                    <span className="rounded-full border border-aqua/40 px-3 py-1 font-mono text-[10px] text-aqua uppercase">
                      {b.status}
                    </span>
                    <a
                      href={`https://wa.me/${b.phone.replace(/\D/g, "")}`}
                      target="_blank"
                      rel="noreferrer"
                      className="text-sm text-wa hover:underline underline-offset-4"
                    >
                      Contactar
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Admin;
